<template>
	<div ref="footerTipsNode" class="list-footer-tips">
		<!-- <span>没有更多数据</span> -->
		<template v-if="more">
			<span>{{ $t('enterprise.effort-loading') }}</span>
			<svg aria-hidden="true" class="more-style animation-rotate">
				<use xlink:href="#icon-mokuaijiazai"></use>
			</svg>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		more: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			loadObserver: null
		};
	},
	beforeDestroy() {
		this.uninstall();
	},
	methods: {
		uninstall() {
			if (this.loadObserver) {
				this.loadObserver.unobserve(this.$refs.footerTipsNode);
			}
		},
		install() {
			this.uninstall();

			const observerOptions = {
				root: null, // 默认是视口
				rootMargin: '0px',
				threshold: 0.1
			};
			const _observer = new IntersectionObserver(entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						this.$emit('load-more');
					}
				});
			}, observerOptions);
			_observer.observe(this.$refs.footerTipsNode);
			this.loadObserver = _observer;
		}
	}
};
</script>

<style lang="less" scoped>
.list-footer-tips {
	background: #ffffff;
	color: #afafaf;
	line-height: 0.5rem;
	font-size: 0.13rem;
	display: flex;
	justify-content: center;
	align-items: center;

	.more-style {
		width: 0.14rem;
		height: 0.14rem;
		margin: 0 0.1rem;
	}
}
</style>
